<template>
  <div class="row">
    <yukyu-menu></yukyu-menu>
    <div class="col-md-10 pt-3">
        <table class="table table-bordered table-responsive">
            <thead class="thead-light">
                <tr>
                    <th>年</th>
                    <th>ヶ月</th>
                    <th>以降</th>
                    <th>有給付与数</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(result, index) in yukyuManageList" :key="index">
                    <td>{{result.year}}</td>
                    <td>{{result.month}}</td>
                    <td>
                        <span v-if="result.last == 0"></span>
                        <span v-if="result.last == 1">〜</span>
                    </td>
                    <td>{{result.yukyuDays}}</td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import LeaveRequestAPI from '../../../api/leave-request-api'
import YukyuMenu from './YukyuMenu.vue'

export default {
  name: "yukyu-management",
  components: {
    YukyuMenu,
  },
  data() {
    return {
      yukyuManageList: []
    }
  },
  watch: {
  },
  mounted () {
    this.getYukyuManageList()
  },
  methods: {
    // 有給一覧取得
    getYukyuManageList () {
      this.$root.$refs.loading.$data.show = true
      LeaveRequestAPI.getYukyuManageList()
        .then(res => {
            this.yukyuManageList = res
            this.$root.$refs.loading.$data.show = false
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    }
  },
  filters: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/yukyu/YukyuManagement.vue